export function canAccessPlansSection(role?: string | null) {
  return role === 'admin' || role === 'supervisor'
}
